//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';

export default {
  components: {},
  props: ["device"],
  computed: { },
  data() {
    return {
		  userIsAdmin: false,
      playlistHeredity: null,
      playlistHeredityOptions: [
        { label: 'Use Device Playlists', value: 'device' },
        { label: 'Use Group Playlists', value: 'group' },
        { label: 'Use Device and Group Playlists', value: 'deviceAndGroup' },
      ],
    };
  },
  created() {
	  if(this.$route.query.adm !== undefined) this.userIsAdmin = true;
    this.initPlaylistHeredity();
  },
  watch: { 
    device: function() {
      this.initPlaylistHeredity()
    }
  },
  methods: {
    ...mapActions([
      "updatePlaylistHeredity"
    ]),
    onPlaylistHeredityChange() {
      this.updatePlaylistHeredity({ deviceId: this.device.DID, playlistHeredity: this.playlistHeredity.value });
    },
    initPlaylistHeredity() {
      this.playlistHeredity = this.playlistHeredityOptions.find(option => option.value == this.device.playlistHeredity);
    },
  },
};
